export enum ConfigLoaderText {
  LOADER_FOR_PUT = 'PUT',
  LOADER_FOR_GET = 'GET',
}
